// Useful constants throughout the app
// ** ONLY USE WHEN LOCAL TESTING DCRUNCH ENDPOINTS! **
export const TESTING_LOCAL_ENDPOINT = false

export const JWT_COOKIE_NAME = 'api_token'
export const NEXT_PUBLIC_APP_ENV = 'NEXT_PUBLIC_APP_ENV'
export const NEXT_PUBLIC_DCRUNCH_API_URL = 'NEXT_PUBLIC_DCRUNCH_API_URL'
export const NEXT_PUBLIC_ROLLBAR_TOKEN = 'NEXT_PUBLIC_ROLLBAR_TOKEN'
export const NEXT_PUBLIC_ROLLBAR_ENABLED = 'NEXT_PUBLIC_ROLLBAR_ENABLED'
export const NEXT_PUBLIC_FULLSTORY_ORG_ID = 'NEXT_PUBLIC_FULLSTORY_ORG'
export const NEXT_PUBLIC_FULLSTORY_ENABLED = 'NEXT_PUBLIC_FULLSTORY_ENABLED'

export const DOCUMENT_CRUNCH_HQ = 'Document Crunch HQ'

export const AI_GENERATED_LABEL = 'Generated by AI'

export const ALL_TEAMS_ID = 'allteams'
export const ALL_TEAMS_OPTION = {
  uuid: ALL_TEAMS_ID,
  text: 'All Teams',
  id: -1,
  customer_id: '123',
}

export const SELECTED_TEAM_ID_KEY = 'selectedTeamId'
export const SELECTED_TEAM_NAME_KEY = 'selectedTeam'
export const SELECTED_CUSTOMER_ID_KEY = 'selectedCustomerId'
